import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainPage from "../pages/mainPage";
import About from "../pages/about";
import Products from "../pages/products";
import Industries from "../pages/industries";
import Contact from "../pages/contant";
import Navbar from "../components/Navbar/Navbar";
import Footer from '../components/Footer/Footer'

const AppRoutes = () => {
  return (
    <Router>
      <Navbar/>
      <Routes>
        <Route path="/" element={<MainPage/>} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer/>
      <a href="#" class="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top"><i class="bi bi-arrow-up"></i></a>
      <a href="https://wa.me/8368771407" target="_blank" class="btn btn-success wtb-fixed height-icon-wtb">
  <i class="fab fa-whatsapp"></i>
</a>
    </Router>
  );
};

export default AppRoutes;
